
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.408 7.617l-.637-.003c-.307-.003-.657-.005-1.051-.005-1.71 0-3.115-1.203-3.115-2.669V2.367c0-.202-.19-.367-.426-.367H6.201C3.878 2 2 3.62 2 5.607v8.62C2 16.311 3.967 18 6.395 18h7.412C16.123 18 18 16.39 18 14.402V7.977c0-.203-.19-.367-.427-.367l-.344.003c-.304.002-.611.004-.82.004zm-3.486 3.09a.792.792 0 01-.992-.002l-1.495-1.277v3.861c0 .33-.314.596-.701.596-.387 0-.7-.267-.7-.596V9.428l-1.498 1.277a.79.79 0 01-.99.002.535.535 0 01-.003-.842l2.694-2.3v-.001a.713.713 0 01.227-.128.803.803 0 01.765.127l.002.002 2.693 2.3a.535.535 0 01-.002.842z","fill":"#94A3B8"}}),_c('path',{attrs:{"d":"M13.071 2.721c0-.345.491-.516.773-.267.652.575 1.614 1.427 2.483 2.195l1.306 1.154c.275.244.073.646-.323.647-.773.001-1.685 0-2.341-.007-1.04 0-1.898-.728-1.898-1.612V2.72z","fill":"#94A3B8"}})])
          )
        }
      }
    